import React from 'react';
import { Stack } from 'react-bootstrap';
import { FaLocationDot } from 'react-icons/fa6';
import { Course } from '../../../types/course.type';
import { CourseLink } from './CourseVenueDistance';

interface CourseVenueProps {
  course: Course;
  color: string;
  fillStyle: React.CSSProperties;
}

export const CourseVenue: React.FC<CourseVenueProps> = ({ course, color, fillStyle }) => {
  return (
    <Stack
      direction="horizontal"
      gap={1}
      className="course-card-venue"
    >
      <FaLocationDot
        size={16}
        style={fillStyle}
        className={`course-card-venue-icon ${color}`}
      />
      <div className="course-card-venue-body">
        <CourseLink
          color={color}
          content={course.venue.title}
          url={``}
        />
      </div>
    </Stack>
  );
};
